import React from 'react';

const Assignment = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Assignment
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          This Agreement is binding upon the parties, their heirs, personal
          representatives, guardians and successors, and to the extent
          assignable, on the assigns of the parties hereto. Buyer will not
          transfer or assign this Agreement without the written consent of
          Seller unless otherwise stated in this Agreement. Assignment of this
          Agreement may result in additional transfer taxes.
        </li>
      </ol>
    </div>
  );
};

export default Assignment;
